module.exports = __webpack_public_path__ + "static/media/icon-individual_leaderboard-not_selected.db95aa0e.svg";